import React, { useState } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { selectLoading, selectMailingLabelLayouts, generateContactMailingLabels, generatePropertyMailingLabels } from 'data/campaigns';
import Modal from 'components/base/Modal';
import Radio from 'components/base/Radio';
import Button, { SolidButton } from 'components/Button';
import { getPopupRegistration, openPopup, Priority } from 'app/PopupHolder';

import css from './style.scss';
import ToggleList from '../../Search/Header/searchFilterNew/shared/ToggleSection/ToggleList';

// Figma spec is a single plain-text run (Inter, one size, no baseline shifts)
// using the compact Unicode fraction glyph, e.g. `1” x 2⅝”`.
const LABEL_FRACTIONS = {
  '1/2': '½', '1/3': '⅓', '2/3': '⅔', '1/4': '¼', '3/4': '¾',
  '1/5': '⅕', '2/5': '⅖', '3/5': '⅗', '4/5': '⅘',
  '1/6': '⅙', '5/6': '⅚', '1/8': '⅛', '3/8': '⅜', '5/8': '⅝', '7/8': '⅞',
};

const formatLabelDimensions = (text) => (text || '')
  .replace(/(\d+)\/(\d+)/g, match => LABEL_FRACTIONS[match] || match)
  .replace(/"/g, '”');

const MailingLabels = ({ loading, layouts, closePopup, propertySearch, contactSearch, generateContactMailingLabels, generatePropertyMailingLabels }) => {
  const [state, setState] = useState({
    layoutId: layouts.getIn([0, 'id']),
    offset: '',
    format: 'docx',
  });

  const generateLabelsClick = () => {
    const { format, offset, layoutId } = state;
    const numericOffset = offset === '' ? 0 : Number(offset);

    if (propertySearch) generatePropertyMailingLabels(layoutId, numericOffset, format, propertySearch, closePopup);
    else generateContactMailingLabels(layoutId, numericOffset, format, contactSearch, closePopup);
  };

  const handleChange = (ev) => {
    const { name, value } = ev.target || ev;

    if (name === 'offset') {
      if (value !== '' && (!/^\d+$/.test(value) || Number(value) > 29)) return;
      setState({ ...state, offset: value });
      return;
    }

    setState({ ...state, [name]: value });
  };

  return (
    <Modal isOpen uniqId="mailingLabels" width="784px" maxHeight="718px" padding="32px" isCloseButton caption='Generate Mailing Labels'subcaption ={`${(propertySearch || contactSearch).selected} Contacts Selected`} customCloseBtnCls="custom-close" closeBtnStyle={{ top: '34px', right: '28px'}} >
      <div className={css.mailingLabels}>
        <div className={css.layouts}>
          {layouts.map(l => (
            <div key={l.get('id')} className={classNames(css.layout, { [css.selected]: l.get('id') === state.layoutId })} onClick={() => handleChange({ name: 'layoutId', value: l.get('id') })}>
              <div className={css.imageContainer}>
                <img className={css.image} src={ l.get('id') === state.layoutId ? l.get('selectedimageUrl') : l.get('imageUrl')} alt={l.get('name')} />
              </div>
              <div className={css.name}>{formatLabelDimensions(l.get('name'))}</div>
              <div className={css.dimensions}>{formatLabelDimensions(l.get('dimensions'))}</div>
            </div>
          ))}
        </div>
        <div className={css.optionscontainer}>
          <div className={css.option}>
            <label className={css.optionLabel}>Offset</label>
            <input onChange={handleChange} name="offset" placeholder="Enter Number" type="text" value={state.offset || ''} maxLength={2} />
            <div className={css.info}>This number of label positions will be skipped on the first sheet.</div>
          </div>
          <div className={css.option}>
            <label className={css.optionLabel}>File Format</label>

            <div className={css.toggleGroup}>
              <button
                type="button"
                className={classNames(css.toggleBtn, { [css.active]: state.format === 'docx' })}
                onClick={() => handleChange({ target: { name: 'format', value: 'docx' } })}
              >
                Word
              </button>
              <button
                type="button"
                className={classNames(css.toggleBtn, { [css.active]: state.format === 'pdf' })}
                onClick={() => handleChange({ target: { name: 'format', value: 'pdf' } })}
              >
                PDF
              </button>
            </div>
          </div>
        </div>
        <div className={css.footer}>
          <button className={css.btnSecondary} onClick={closePopup} loading={loading}>
            Close
          </button>
          <button className={css.btnPrimary} onClick={generateLabelsClick} loading={loading}>
            Generate Labels
          </button>
        </div>
      </div>
    </Modal>
  );
};

const MailingLabelsPopup = connect(state => ({
  loading: selectLoading(state),
  layouts: selectMailingLabelLayouts(state),
}), {
  generateContactMailingLabels,
  generatePropertyMailingLabels,
})(MailingLabels);

const registrationId = getPopupRegistration(MailingLabelsPopup);
MailingLabelsPopup.open = (props = {}) => openPopup(registrationId, { ...props, priority: Priority.MEDIUM });

export default MailingLabelsPopup;
